import { render, staticRenderFns } from "./InterviewUnsupported.vue?vue&type=template&id=368a4e0e&"
import script from "./InterviewUnsupported.vue?vue&type=script&lang=js&"
export * from "./InterviewUnsupported.vue?vue&type=script&lang=js&"
import style0 from "./InterviewUnsupported.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports